// Estimate time-series query hook (analytics.rs).
//   GET /v1/screens/{id}/estimates?from=&to= (RFC3339 instants, both optional
//   — the server defaults to the trailing 24h when omitted).
//
// The response carries the points AND the service outages over the same window,
// so the chart can shade an outage across the series it draws without a second
// request that might disagree about where the range ends.

import { useQuery } from "@tanstack/react-query";
import { http } from "./http";
import { estimateKeys } from "./keys";
import type { EstimateSeries } from "./types";

export interface EstimatesRange {
    from?: string;
    to?: string;
}

export function useEstimates(screenId: string, range: EstimatesRange = {}) {
    const { from, to } = range;
    return useQuery({
        queryKey: estimateKeys.list(screenId, from ?? "", to ?? ""),
        queryFn: () => {
            const params = new URLSearchParams();
            if (from) params.set("from", from);
            if (to) params.set("to", to);
            const query = params.toString();
            return http.get<EstimateSeries>(`/v1/screens/${screenId}/estimates${query ? `?${query}` : ""}`);
        },
        enabled: Boolean(screenId),
    });
}
